export const Custom = {
  colorPrimary: "#8b5afd", //005ce8 //7D23EB
  colorError: "#dc3545",
  colorSuccess: "#28a745",
  borderRadius: 10,
  borderColor: "#f0f0f0",
  fontFamily: "sans-serif",
  colorLight: "#949494",
  colorBgContainer: "#fff",
  colorBg: "#f5f5f5",
  colorBgLayout: "#fff",
  Button: {
    borderRadius: 10,
  },
  Input: {
    borderRadius: 10,
  },
  Select: {
    borderRadius: 10,
  },
  Textarea: {
    borderRadius: 10,
  },
  Checkbox: {
    borderRadius: 10,
  },
  CheckboxGroup: {
    borderRadius: 10,
  },
  InputNumber: {
    borderRadius: 10,
  },
  Layout: {
    Header: {},
    Menu: {},
  },
};

export const Styles = {
  colorPrimary: "#8b5afd",
  colorBlue: "#005ce8",
  colorError: "#dc3545",
  colorSuccess: "#28a745",
  theme_bg: "#f5f5f5",
  borderColor: "#f0f0f0",
  gray: "#858a99",
  colorLight: "#949494",
  fontFamily: "Poppins-Regular",
  input_size: "large",
  table_size: "middle",
};
